import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'

function getPlugin({ sessionReplay }: Analytics.IdConfig) {
  const DEFAULT_SESSION_REPLAY_SAMPLE_RATE = 0.05

  const sessionReplayPluginInstance = sessionReplayPlugin({
    sampleRate: sessionReplay?.sampleRate || DEFAULT_SESSION_REPLAY_SAMPLE_RATE,
    forceSessionTracking: true,
    debugMode: true,
  })

  return sessionReplayPluginInstance
}

export default {
  getPlugin,
}
